"use client";

import {withClientPdf} from "@/components/common/withClientPdf";

const InlinePdfPreview = withClientPdf(() => import("./InlinePdfPreviewInner"), "lg");

export default InlinePdfPreview;
